import { PlusIcon } from "@heroicons/react/solid";
import { MeetingViewMeetingNodeNewPageFragmentFragment } from "types/graphql-schema";

import Button from "@components/button/button";
import { ButtonSize } from "@components/button/button-constants";

import { createTopicInMeeting } from "../helpers";

const AddTopicHover = ({
  meeting,
  afterTopicId,
  beforeTopicId,
  hideButton = false,
}: {
  meeting: MeetingViewMeetingNodeNewPageFragmentFragment;
  afterTopicId?: number;
  beforeTopicId?: number;
  hideButton?: boolean;
}) => {
  const handleClickAdd = () => {
    createTopicInMeeting({
      meeting,
      afterTopicId,
      beforeTopicId,
    });
  };

  if (!meeting.canUpdate?.permission) return null;

  return (
    <div className="relative h-px w-full">
      <div className="h-px bg-gray-200" />
      {!hideButton && (
        <div className="group/add-topic absolute left-1/2 -translate-x-1/2 -translate-y-1/2 top-1/2 h-6 flex items-center">
          <Button
            onClick={handleClickAdd}
            size={ButtonSize.medium}
            className="gap-1 tracking-tight opacity-0 group-hover/add-topic:opacity-100"
          >
            <PlusIcon className="w-4 h-4" />
            Add Topic
          </Button>
        </div>
      )}
    </div>
  );
};

export default AddTopicHover;
